import { Component, OnInit, inject, signal } from "@angular/core"
import { Router } from "@angular/router"
import { StepsService } from "src/app/services/steps.service"

@Component({
  selector: "ow-data-form",
  templateUrl: "./data-form.component.html"
})
export class DataFormComponent implements OnInit {
  private readonly router = inject(Router)
  private readonly stepsService = inject(StepsService)

  validity = {
    "business-data": false,
    "contact-person": false,
    "business-banking": false,
    porting: false,
    "phone-book": false
  }
  isValid = signal<boolean>(false)

  ngOnInit(): void {
    this.stepsService.enableStep("data-form")
  }

  public prevStep(): void {
    this.router.navigateByUrl("/product-options")
  } 

  public nextStep(): void {
    this.stepsService.enableStep("order-summary")
    this.router.navigateByUrl("/order-summary")
  } 

  public updateValidity(form: "business-data" | "contact-person" | "business-banking" | "porting" | "phone-book", isValid: boolean) {
    if (this.validity[form] !== isValid) {
      this.validity[form] = isValid
      this.isValid.set((Object.values(this.validity).filter((isValid) => !isValid).length === 0))
    }
  }

}
